import { FormControl as MUIFormControl, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomSwitch = styled(Switch)`
  && .MuiInputBase-root {
    border-radius: 10px;
  }
`;

export const FormControl = styled(MUIFormControl)`
  text-align: initial;
`;
